import { useNavigate } from 'react-router-dom';

import { Text } from 'components';
import { cn } from 'utils';
import { GetStartedMetadata } from './types';

interface Props extends GetStartedMetadata {
  className?: string;
}

const GetStartedButton = ({ icon, title, subtitle, path, description, className, subtitleColor }: Props) => {
  const navigate = useNavigate();

  function onClickButton() {
    navigate(path);
  }

  return (
    <button
      type="button"
      className={cn(
        className,
        'flex w-full max-w-full flex-col items-center justify-center gap-4 rounded border p-4',
        'border-border-primary',
        '[&>svg]:h-[78px] [&>svg]:w-[78px]',
        'md:h-full',
        'max-h-80',
      )}
      onClick={onClickButton}
    >
      {icon}
      <div className={cn('w-full max-w-full', 'md:h-auto md:w-[400px]')}>
        <Text size="small" style={{ color: subtitleColor }}>{subtitle}</Text>
        <h3 className="mb-2 mt-2 text-heading3 font-medium text-text-primary">{title}</h3>
        <Text color="secondary" size="body2" weight="regular" className="max-w-full whitespace-pre-wrap">
          {description}
        </Text>
      </div>
    </button>

  );
};

export default GetStartedButton;
